import { AnimationLoadingScreenWithProgressBar } from '../../../components/loading/loadingScreen';
import { AuthenticatePageJSXOnly } from './authenticatePage.components';
import { useAuthenticationLogic, useUserDataFetcher } from './authenticatePage.hooks';

/**
 * Renders a component for email authentication.
 *
 * @returns {JSX.Element|string} - The rendered component or a string indicating unauthorized access.
 * @throws {Error} - If an error occurs during the verification process.
 */
export const AuthenticatePage = ( { factor } ) => {
  const { email, routerPassword, maskedEmail, maskedPhone, params, fromEmailLink } = useUserDataFetcher();
  const {
    code,
    setCode,
    incorrect,
    isLoading,
    responseReturned,
    errorMessage,
    handleAuthenticate,
    handleSendAuthCode,
    sendNewCodeActivated,
  } = useAuthenticationLogic( email, routerPassword, factor, params, fromEmailLink );

  return isLoading ? (
    <AnimationLoadingScreenWithProgressBar title="Loading..." secondsToLoad={ 30 } isAlmostComplete={ responseReturned } />
  ) : email !== '' ? (
    <AuthenticatePageJSXOnly
      disabled={ code.length !== 6 ? true : false }
      factor={ factor }
      email={ email }
      maskedEmail={ maskedEmail }
      maskedPhone={ maskedPhone }
      code={ code }
      setCode={ setCode }
      incorrect={ incorrect }
      errorMessage={ errorMessage }
      sendNewCodeActivated={ sendNewCodeActivated }
      handleAuthenticate={ handleAuthenticate }
      handleSendAuthCode={ handleSendAuthCode }
    />
  ) : (
    'Unauthorized.'
  );
};
